const emailToParams = (userInfo: any, email: string) => {
  const phone = userInfo?.telecom.find((item: any) => item.system === 'phone');
  return {
    resource: {
      ...userInfo,
      telecom: [
        {
          isNew: true,
          system: 'email',
          value: email,
        },
        phone,
      ],
    },
  };
};

export default emailToParams;
